import {Component, OnInit} from '@angular/core';
import {Router, NavigationEnd, NavigationStart, NavigationCancel, NavigationError} from '@angular/router';
import {Location} from '@angular/common';
import {SessionService} from './services/session.service';
// import {$} from 'protractor';
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'trustii-ui';
  currentUrl: string;
  loading = false;
  sessionAvailable = false;
  collapsedMenu = false;

  constructor(
    private router: Router,
    private location: Location,
    public sessionService: SessionService
  ) {
    this.router.events.subscribe((event) => {
      this.currentUrl = this.location.path();
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationCancel ||
        event instanceof NavigationError ||
        event instanceof NavigationEnd
      ) {
        this.loading = false;
      }
    });
  }

  ngOnInit(): void {
    $('body').tooltip({
      selector: '[data-toggle="tooltip"]',
    });
    $('body').popover({ selector: '[data-toggle="popover"]' });
    $('body').on('click', (e) => {
      if (
        typeof $(e.target).data('original-title') === 'undefined' &&
        !$(e.target).parents().is('.popover.in')
      ) {
        $('[data-original-title]').popover('dispose');
      }

      $('.tooltip').tooltip('dispose');
    });

  }

  toggleNavMenu() {
    this.collapsedMenu = !this.collapsedMenu;
  }
}
